// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2YFML","productName":"Table_productName__1VrHk"};